export const group = (props) => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M17.849 11.809L17.142 11.102L7.242 21.002H3V16.759L14.313 5.445L19.97 11.102C20.1575 11.2895 20.2628 11.5438 20.2628 11.809C20.2628 12.0742 20.1575 12.3285 19.97 12.516L12.9 19.587L11.485 18.173L17.849 11.809ZM15.728 9.68801L14.313 8.274L5 17.587V19.002H6.414L15.728 9.68801ZM18.556 2.61701L21.385 5.445C21.5725 5.63253 21.6778 5.88684 21.6778 6.15201C21.6778 6.41717 21.5725 6.67148 21.385 6.859L19.97 8.274L15.728 4.03101L17.142 2.61701C17.3295 2.42953 17.5838 2.32422 17.849 2.32422C18.1142 2.32422 18.3685 2.42953 18.556 2.61701Z'
        fill='#3D434C'
      />
    </svg>
  );
};